export default "/_next/static/images/af2f95279009b92d74d6455c8216b328.png";